import { find } from 'lodash';
import { countries } from '../constants';

export const getCountryValueFromKey = key => {
  const matchingCountry = find(countries, country => country.key === key);
  return matchingCountry ? matchingCountry.value : 'All';
};

export const getCountryKeyFromValue = value => {
  const matchingCountry = find(countries, country => country.value === value);
  return matchingCountry ? matchingCountry.key : 'All';
};



// WEBPACK FOOTER //
// ./src/helpers/countryHelper.js